import {Field, FieldType} from './Field';
import {FieldId, SectionId} from './types';
import {TranslatedWord} from './FieldConfiguration';
import {TextAreaFieldQL} from '../graphql/TextAreaFieldQL';

/**
 * Represents a custom textarea field
 */
export default class TextAreaField implements Field {
  readonly id: FieldId
  readonly type: FieldType
  readonly sectionId: SectionId
  readonly label: string
  readonly labels: TranslatedWord[]

  constructor(input: TextAreaFieldQL) {
    this.id = input.id;
    this.type = FieldType.TextArea;
    this.sectionId = input.sectionId;
    this.label = input.label;
    this.labels = input.labels;
  }

  /**
   * Returns true if it's possible to convert the field to the new type
   */
  // eslint-disable-next-line class-methods-use-this
  canConvertTo(newType: FieldType): boolean {
    return newType === FieldType.Text || newType === FieldType.TextArea;
  }
}
